module.exports = __webpack_public_path__ + "static/fv_user_pc-6a95f34c07b147863cde74c6569d2054.png";